import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { createContext, Dispatch, ReactNode, useState } from 'react'
import { SiteDetailsResponse } from '../apis/siteDetails/dto'
import { SiteDetailsApi } from '../apis/siteDetails/siteDetailsApi'
import useAuth from '../hooks/useAuth'

type SiteDetailsContextType =
  | (UseQueryResult<AxiosResponse<SiteDetailsResponse, any>, Error> & {
      setIsEnabled: Dispatch<boolean>
    })
  | undefined
export const SiteDetailsContext =
  createContext<SiteDetailsContextType>(undefined)

export const siteDetailsQueryKey = ['siteDetails']

interface SiteDetailsProviderProps {
  children: ReactNode
}

const refetchTime = 15 * 1000 // 15 seconds

export const SiteDetailsProvider = ({ children }: SiteDetailsProviderProps) => {
  const { isAuthenticated } = useAuth()
  const [isEnabled, setIsEnabled] = useState<boolean>(true)
  const siteDetailsQuery = useQuery({
    queryKey: siteDetailsQueryKey,
    queryFn: SiteDetailsApi.getSiteDetails,
    enabled: isAuthenticated && isEnabled,
    refetchInterval: refetchTime,
    refetchOnReconnect: true,
    refetchIntervalInBackground: true,
    retry: false,
  })

  return (
    <SiteDetailsContext.Provider value={{ setIsEnabled, ...siteDetailsQuery }}>
      {children}
    </SiteDetailsContext.Provider>
  )
}
